import { render, staticRenderFns } from "./TransactionIndex.vue?vue&type=template&id=5f68a4e0"
import script from "./TransactionIndex.vue?vue&type=script&lang=ts"
export * from "./TransactionIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports